import { render, staticRenderFns } from "./templateSayhiTwo.vue?vue&type=template&id=9b655094&scoped=true"
import script from "./templateSayhiTwo.vue?vue&type=script&lang=js"
export * from "./templateSayhiTwo.vue?vue&type=script&lang=js"
import style0 from "./templateSayhiTwo.vue?vue&type=style&index=0&id=9b655094&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b655094",
  null
  
)

export default component.exports